import { getItemsFromApiResponse } from '../../../../utils/api'

export function getEditTypeModalSelectApiData(response) {
  return getItemsFromApiResponse(response)?.filter(item => item.enabled)
}

export function getEditTypeModalMetaData(response) {
  return {
    page: response?.data?.meta?.curr_page,
    page_count: response?.data?.meta?.page_count,
    size: response?.data?.meta?.limit,
  }
}

export function getEditTypeModalValue(item) {
  return item?.id
}

export function getEditTypeModalLabel(item) {
  return item?.name
}
